<template>
  <BaseSection :step="step">

    <template #title>Update Tariff</template>

    <template #content>
      <v-form>

        <v-row class="narrowInputs">
          <v-col>
            <v-select v-model="tariff" :items="groupedTariffs" label="Tariff" return-object outlined dense hide-details :loading="getTariffsLoading" :disabled="getTariffsLoading" />
          </v-col>
        </v-row>

        <v-row class="narrowInputs">
          <v-col>
            <v-select v-model="length" :items="getTariffLengths" label="Contract Length Months" return-object outlined dense hide-details :loading="getTariffsLoading" :disabled="getTariffsLoading" />
          </v-col>
        </v-row>

        <v-row class="narrowInputs">
          <v-col>
            <v-select v-model="promo" :items="getTariffPromos" label="Promo" return-object outlined dense hide-details :loading="getTariffsLoading" :disabled="getTariffsLoading" />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-btn color="primary" outlined class="my-0 mr-2" @click="submitBack">Back</v-btn>
            <v-btn color="primary" class="my-0" @click="submitContinue" :disabled="disableContinue">Continue</v-btn>
          </v-col>
        </v-row>

      </v-form>
    </template>

  </BaseSection>
</template>

<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex';
  import BaseSection from '@/components/Products/ProductTypes/AllProducts/ChangeTariff/Sections/BaseSection';
  
  export default {
    props: {
      step: {
        type: Number,
        default: 0
      },
    },

    components: { BaseSection },

    computed: {
      ...mapGetters('changeTariff',['getCurrentStep','getSection','getTariffs','getTariffLengths','getTariffPromos','getTariffsLoading','getChangeReason']),
      ...mapGetters('products',['getCurrentProduct']),

      disableContinue(){
        return (!this.tariff||!this.length||!this.promo) || (this.getTariffsLoading || !this.tariff.text || !this.length.text || !this.promo.text);
      },

      tariff: {
        get() { return this.getSection('tariff').tariff; },

        set(val){
          this.set_section({section:['tariff','tariff'],value:val});
          this.set_section({section:['tariff','length'],value:{}});
          this.set_section({section:['tariff','promo'],value:{}});
        }
      },

      length: {
        get() { return this.getSection('tariff').length; },

        set(val){
          this.set_section({section:['tariff','length'],value:val});
          this.set_section({section:['tariff','promo'],value:{}});
        }
      },

      promo: {
        get() { return this.getSection('tariff').promo; },

        set(val){
          this.set_section({section:['tariff','promo'],value:val});
        }
      },
    
      groupedTariffs() {
        const categorizedTariffs = this.getTariffs.reduce((final, tariff) => {
          if (tariff.category) {
            if(!final.hasOwnProperty(tariff.category)) {
              final[tariff.category] = [];
              final[tariff.category].push(tariff);
            } else {
              final[tariff.category].push(tariff);
            }
          } else {
            final["Other"] = [];
            final["Other"].push(tariff);
          }
          return final;
        }, {});

        const sortedTariffs = Object.keys(categorizedTariffs).sort().reduce((final, category) => {
          final[category] = [...categorizedTariffs[category]];
          return final;
        }, {});

        return Object.entries(sortedTariffs).reduce((final, [category, tariffs]) => {  
          const header = { header: category };
          const divider = { divider: true };
          const group = [header, ...tariffs, divider];

          final.push(...group);

          return final;        
        }, []);
      }
    },

    watch: {
      async getCurrentStep(val) {
        if(val===this.step){
          if(this.getTariffs.length===0){
            await this.fetchTariffs(this.getCurrentProduct);
          }else{
            this.set_previous_tariffs(this.getCurrentProduct);
          }

          if(this.getChangeReason.value === "CONTRACT_RENEWALS") {
            this.set_section({section:['tariff','promo'],value:{text:"No Promo",value:null}});
          } 
        }
      },
    },

    methods: {
      ...mapActions('changeTariff',['fetchTariffs']),
      ...mapMutations('changeTariff',['set_section','set_stepNext','set_stepPrev','reset_section_tariff','set_previous_tariffs']),

      submitContinue(){
        this.set_stepNext();
      },

      submitBack(){
        this.reset_section_tariff();
        this.set_stepPrev();
      },
    },
  }
</script>

<style lang="scss" scoped></style>
